// Base
export const BASE_PATH = "/profile";

// Params
export const ID_PARAM = ":id";

export const VIEW_PIN_PARAM = ":viewPin";

export const VIEW_PIN_PATTERN = /\d{4}-\d{4}-\d{4}/;

// View Pin
export const VIEW_PIN_PATH = `/${VIEW_PIN_PARAM}`;

// Profile sections
export const EDIT_PHOTO_PATH = "photos";

export const EDIT_PHOTO_FULL_PATH = `${BASE_PATH}/${EDIT_PHOTO_PATH}`;

export const CREDITS_PATH = "credits";

export const CREDITS_FULL_PATH = `${BASE_PATH}/${CREDITS_PATH}`;

export const EDIT_CREDIT_PATH = `${CREDITS_PATH}/edit/:creditId?`;

export const EDIT_CREDIT_FULL_PATH = `${BASE_PATH}/${EDIT_CREDIT_PATH}`;

export const ADD_CREDIT_PATH = `${CREDITS_PATH}/addcredit`;

export const ADD_CREDIT_FULL_PATH = `${BASE_PATH}/${ADD_CREDIT_PATH}`;

export const BASIC_DETAILS_PATH = "details";

export const BASIC_DETAILS_FULL_PATH = `${BASE_PATH}/${BASIC_DETAILS_PATH}`;

export const SKILLS_PATH = "skills";

export const SKILLS_FULL_PATH = `${BASE_PATH}/${SKILLS_PATH}`;

// Contacts / agencies
export const PROFILE_CONTACT_PATH = "contacts";

export const PROFILE_CONTACT_FULL_PATH = `${BASE_PATH}/${PROFILE_CONTACT_PATH}`;

export const CONTACT_ADD_PATH = `${PROFILE_CONTACT_PATH}/add`;

export const CONTACT_ADD_FULL_PATH = `${BASE_PATH}/${CONTACT_ADD_PATH}`;

export const CONTACT_NEW_PATH = `${PROFILE_CONTACT_PATH}/new`;

export const CONTACT_NEW_FULL_PATH = `${BASE_PATH}/${CONTACT_NEW_PATH}`;

export const CONTACT_HELP_PATH = `${PROFILE_CONTACT_PATH}/help`;

export const CONTACT_HELP_FULL_PATH = `${BASE_PATH}/${CONTACT_HELP_PATH}`;

// Social / links
export const SOCIAL_LINKS_PATH = "links";

export const LINK_TO_PROFILE_PATH = "linktoprofile";

// Media
export const MEDIA_PATH = "media";

export const MEDIA_FULL_PATH = `${BASE_PATH}/${MEDIA_PATH}`;

export const MEDIA_ADD_PATH = `${MEDIA_PATH}/add`;

export const MEDIA_ADD_FULL_PATH = `${BASE_PATH}/${MEDIA_ADD_PATH}`;

export const VIDEO_PATH = `${MEDIA_PATH}/video`;

export const EDIT_VIDEO_PATH = `${VIDEO_PATH}/edit/${ID_PARAM}`;

export const EDIT_VIDEO_FULL_PATH = `${BASE_PATH}/${EDIT_VIDEO_PATH}`;

export const AUDIO_PATH = `${MEDIA_PATH}/audio`;

export const EDIT_AUDIO_PATH = `${AUDIO_PATH}/edit/${ID_PARAM}`;

export const EDIT_AUDIO_FULL_PATH = `${BASE_PATH}/${EDIT_AUDIO_PATH}`;

// Public
export const SOCIAL_CONNECT_COMPLETE_PATH = `social-connect/complete`;

// Utility
export const NOT_FOUND_PATH = "404";

export const NOT_FOUND_FULL_PATH = `${BASE_PATH}/${NOT_FOUND_PATH}`;

export const LOGOUT_PATH = "logout";

export const MY_VIEW_PIN_PATH = "myviewpin";
